import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ChartComponent } from '../../../core/chart/chart.component';
import { FormatPipe } from '../../../../pipes/format.pipe';

@Component({
  selector: 'app-sidekick-chart',
  imports: [ChartComponent, FormatPipe],
  template: ` <div class="tw-flex tw-gap-2 tw-items-center">
    <div class="tw-w-full">
      <div class="tw-font-bold tw-text-[1.2rem]">{{ title }}</div>
      <div class="tw-flex tw-gap-2 tw-pb-4 tw-items-center">
        <div class="tw-w-full" style="width: 250px;">
          <app-chart [config]="dataSource.configData" tooltipPrefixLabel="$" />
          @if (hasPartyDeductible) {
            <div class="tw-flex tw-flex-row tw-pt-2 tw-gap-1">
              <div
                class="tw-font-bold tw-text-[0.85rem] tw-text-[var(--sed-black-60-color)]"
              >
                1st Party Deductible
              </div>
              <div class="tw-font-bold tw-text-[0.85rem]">
                {{ dataSource.firstPartyDeductible | format: 'c' }}
              </div>
            </div>
          }
        </div>
        <div class="tw-w-full">
          @for (s of dataSource.configData.series; track s) {
            <div class="tw-w-full tw-flex tw-pb-2">
              <div
                class="tw-grow-0 tw-min-w-4 tw-rounded-xl tw-mx-2 tw-my-2"
                [style.background-color]="s.color"
              ></div>
              <div class="tw-grow">
                <div
                  class="tw-font-bold tw-text-[0.9rem] tw-text-[var(--sed-black-60-color)]"
                >
                  {{ s.label }}
                </div>
                <div class="tw-font-bold tw-text-[1.1rem]">
                  {{ s.value | format: 'c' }}
                </div>
              </div>
            </div>
          }
          <div
            class="tw-pl-8 tw-font-bold tw-text-[1rem] tw-text-[var(--sed-black-60-color)]"
          >
            Total Incurred
          </div>
          <div class="tw-pl-8 tw-font-bold tw-text-[1.3rem]">
            {{ dataSource.totalIncurred | format: 'c' }}
          </div>
        </div>
      </div>
    </div>
  </div>`,
  styles: [``],
})
export class SidekickChartComponent implements OnInit {
  @ViewChild(ChartComponent) private chartComponent?: ChartComponent;

  @Input() dataSource: any;

  @Input()
  title = 'Totals';

  @Input()
  hasPartyDeductible = true;

  ngOnInit(): void {
    this.dataSource.configData.height = '80px';
    this.dataSource.configData.width = '80px';
  }

  captureDonutImage(): string | null {
    return this.chartComponent?.captureImage() ?? null;
  }
}
